import { classNames } from "@/react/helpers/twMergeWithCN";
import { Form } from "@circle-react-uikit/Form";

export interface SliderConfigProps {
  defaultUnit?: string;
  max?: number;
  min?: number;
  step?: number;
  units?: string[] | ReadonlyArray<string>;
}

export interface SliderFieldProps extends SliderConfigProps {
  className?: string;
  inputClassName?: string;
  label: string;
  name: string;
}

export const SliderField = ({
  name,
  label,
  min = 0,
  max = 100,
  step = 0.1,
  className = "",
  inputClassName = "",
  defaultUnit = "px",
  units = ["px", "%", "rem"],
}: SliderFieldProps) => (
  <Form.Item
    name={name}
    label={label}
    hideDescription
    hideBorder
    labelClassName="!font-normal text-xs"
    className="!p-0"
  >
    <Form.SliderWithInput
      name={name}
      min={min}
      max={max}
      step={step}
      className={classNames("!w-full", className)}
      inputClassName={inputClassName}
      defaultUnit={defaultUnit}
      units={units}
    />
  </Form.Item>
);
